import { useEffect, useState } from 'react'
import { Share } from 'lucide-react'
import { isIosSafari, isStandalone } from '@/core/platform/install'

/**
 * Banner instrutivo para iOS Safari NÃO instalado como standalone.
 *
 * Por que não é dispensável:
 *  - Sem instalar como standalone, Safari mostra URL bar + toolbar no app, cobrindo
 *    parte da viewport e atrapalhando a UX em todas as telas internas.
 *  - O usuário acha que é "bug" — ao tocar em qualquer card a chrome reaparece.
 *  - A solução é instalar pela Tela de Início. Dispensar não resolve, só esconde
 *    a única forma de evitar o problema.
 *
 * Esconde automaticamente quando:
 *  - Não estiver em iOS Safari (Android/Chrome têm install nativo)
 *  - Já estiver rodando standalone (display-mode: standalone OU navigator.standalone)
 */
export function IosInstallBanner() {
  const [show, setShow] = useState(false)

  useEffect(() => {
    const evaluate = () => {
      setShow(isIosSafari() && !isStandalone())
    }
    evaluate()
    // standalone pode mudar se o usuário instalar e voltar pra mesma aba
    const mq = window.matchMedia('(display-mode: standalone)')
    mq.addEventListener('change', evaluate)
    return () => mq.removeEventListener('change', evaluate)
  }, [])

  if (!show) return null

  return (
    <div className="bg-accent/15 border-b border-accent/40 px-4 py-2.5 flex items-start gap-3 text-sm">
      <Share className="h-5 w-5 text-accent flex-shrink-0 mt-0.5" />
      <div className="flex-1">
        <p className="font-medium text-on-surface">Instale na Tela de Início</p>
        <p className="text-on-surface-dim text-xs mt-0.5">
          Sem instalar, o Safari aparece e tampa parte da tela. Toque em{' '}
          <span className="inline-flex items-baseline align-middle">
            <Share className="h-3 w-3 inline mx-0.5 relative top-0.5" />
          </span>{' '}
          (Compartilhar) → <strong>Adicionar à Tela de Início</strong>.
        </p>
      </div>
    </div>
  )
}
